export const projectDetailOutputResult = [
  {
    id: "000954595",
    output: "OutputName",
    theme: "Democratice governance",
    outputDesc: "Updated legislative policy and regulatory framework",
    viewDetails: "View Results",
  },
  {
    id: "000954596",
    output: "OutputName",
    theme: "Responsive institution",
    outputDesc: "Updated legislative policy and regulatory framework",
    viewDetails: "View Results",
  },
  {
    id: "000954597",
    output: "OutputName",
    theme: "Democratice governance",
    outputDesc: "Updated legislative policy and regulatory framework",
    viewDetails: "View Results",
  },
  {
    id: "000954598",
    output: "OutputName",
    theme: "Responsive institution",
    outputDesc: "Updated legislative policy and regulatory framework",
    viewDetails: "View Results",
  },
];



// WEBPACK FOOTER //
// ./static/assets/json/projectDetailOutPutResults.js